/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why a deal email did not go out.
 * 
 * Rides `SendEmailResponse.failure_reason` and is echoed to the operator on the
 * action response, so the two cases must stay distinguishable: a missing LCEP
 * license is a compliance gate an admin fixes in Rippling, a send failure is
 * HelpScout being HelpScout.
 * 
 * `NO_CONVERSATION` is the exception: it is written to the activity feed but never
 * set on `failure_reason`. Nothing failed and nothing was owed to a counterparty,
 * so the operator toast would be lying with either of the sentences it knows.
 * @export
 */
export const EmailFailureReason = {
    LcepLicenseMissing: 'lcep_license_missing',
    SendFailed: 'send_failed',
    NoConversation: 'no_conversation'
} as const;
export type EmailFailureReason = typeof EmailFailureReason[keyof typeof EmailFailureReason];


export function EmailFailureReasonFromJSON(json: any): EmailFailureReason {
    return EmailFailureReasonFromJSONTyped(json, false);
}

export function EmailFailureReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailFailureReason {
    return json as EmailFailureReason;
}

export function EmailFailureReasonToJSON(value?: EmailFailureReason | null): any {
    return value as any;
}

